export enum AnimationClass {
  NEXT = 'next-animation',
  BACK = 'back-animation',
}
